import { PassengersValues } from 'pages/avia/purchase-form/model'

import { CloseCircle } from 'entities/close-circle/model'
import { DOCUMENT, GENDER } from 'entities/user/module'

import { TYPE_AGE } from 'shared/constants'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

export const preparedCloseCircleForm = (
  age: TYPE_AGE,
  data: CloseCircle,
  isAvailable?: boolean,
) => {
  const hasMiddleName = (data?.middle_name?.length || 0) > 2

  const preparedData: PassengersValues = {
    id: data.id,
    firstName: data.first_name,
    lastName: data.last_name,
    middleName: hasMiddleName ? data.middle_name! : '',
    doesMiddleName: !!hasMiddleName,
    citizenship: data.citizenship,
    dateOfBirth: new Date(data.date_of_birth),
    gender: data.gender,
    passport: data.document_type as DOCUMENT,
    serialDocuments: '',
    documentExpirationDate: '',
  }

  if (isAvailable || data?.document_type === DOCUMENT.PASSPORT) {
    preparedData.passport = data.document_type as DOCUMENT
    preparedData.serialDocuments = data.document_number
    preparedData.documentExpirationDate = data.document_expire
  }

  if (
    isAvailable &&
    age !== TYPE_AGE.ADULTS &&
    data?.document_type === DOCUMENT.ID
  ) {
    preparedData.passport = ''
    preparedData.serialDocuments = ''
    preparedData.documentExpirationDate = ''
  }

  if (
    isAvailable &&
    age === TYPE_AGE.ADULTS &&
    data?.document_type === DOCUMENT.BIRTH_CERTIFICATE
  ) {
    preparedData.passport = ''
    preparedData.serialDocuments = ''
    preparedData.documentExpirationDate = ''
  }

  return preparedData
}

export const getPreparedCreateCloseCircle = (
  data: PassengersValues,
): CloseCircle => {
  const hasMiddleName = data?.doesMiddleName

  const preparedPassenger: CloseCircle = {
    document_type: data.passport,
    first_name: data.firstName,
    last_name: data.lastName,
    middle_name: !hasMiddleName ? '-' : data.middleName,
    gender: data.gender as GENDER,
    date_of_birth: dateFormat(
      data.dateOfBirth,
      DATE_FORMAT_LIST.YEAR_FULL_DATE,
    ),
    citizenship: data.citizenship,
    document_number: data.serialDocuments,
    document_expire: dateFormat(
      data.documentExpirationDate,
      DATE_FORMAT_LIST.YEAR_FULL_DATE,
    ),
    expiration_date: data?.documentExpirationDate,
  }

  return preparedPassenger
}
